<template>
<div class="banner" v-if="active" :class="[{ 'is-error': error }]">
    <div class="banner-content animated fadeInDown">
      <div class="container">
        <span class="icon is-medium is-circular" @click="closeFeed">
          <i class="fas" :class="[error ? 'fa-times': 'fa-check']"></i>
        </span>
        <heading>{{ title }}</heading>
      </div>
    </div>
</div>
</template>

<script>
import Heading from '@/components/general/heading'
export default {
  components: { Heading },
  props: {
    title: {
      type: String,
      required: false
    },
    active: {
      type: Boolean,
      required: true
    },
    time: {
      type: Number,
      default: 3000
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    active (newValue, oldValue) {
      if (newValue && !oldValue && this.timer === null) {
        this.timer = window.setTimeout(() => {
          this.$emit('update:active', false)
          this.timer = null
        }, this.time)
      }
    }
  },
  data () {
    return {
      timer: null
    }
  },
  methods: {
    closeFeed () {
      this.$emit('update:active', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

h6.heading {
  color: white;
  margin-bottom: 0;
}

.icon {
  color: $brand-primary;
  margin-right: 14px;
  background-color: white;
  cursor: pointer;
  &:hover {
    opacity: .8;
  }
}
.banner.is-error {
  .icon {
    color: $red;
  }
}
.icon.is-circular {
  border-radius: 50%;
}

$height: 60px;

.banner {
  height: $height;
  visibility: visible;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 300;
  width: 100%;
}

.banner .banner-content {
  background-color: $brand-primary;
  width: 100%;
  height: $height;
  .container {
    padding: 14px;
    display: flex;
    align-items: center;
  }

}
.banner.is-error
{
  // margin-top: -14px;
  .banner-content {
    background-color: $red
  }
}
</style>



// WEBPACK FOOTER //
// src/components/general/banner.vue